import { Link } from "react-router-dom";
import { FiChevronRight, FiHome } from "react-icons/fi";
import { DEFAULT_APP_PATH } from "routes/paths";

export default function AppBreadcrumbs({ items = [], className = "" }) {
  return (
    <nav className={`mb-4 flex flex-wrap items-center gap-2 text-sm ${className}`} aria-label="Breadcrumb">
      <Link
        to={DEFAULT_APP_PATH}
        className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white text-text-500 transition hover:text-brand-900"
      >
        <FiHome size={14} />
      </Link>

      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <div key={`${item.label}-${index}`} className="inline-flex items-center gap-2">
            <FiChevronRight className="text-text-500" size={14} />
            {isLast ? (
              <span className="rounded-full bg-brand-900 px-3 py-1 text-xs font-semibold text-white">
                {item.label}
              </span>
            ) : (
              <Link to={item.path || "/"} className="text-text-500 transition hover:text-brand-900">
                {item.label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
